<template>
  <GalleryGridUI
    :loading-count="loadingCount"
    :loaded-items="loadedItems"
    :total-count="totalCount"
    @load-more="loadMore"
  >
    <template v-slot:item="itemProps">
      <div>
        <img
          @click="onImageClick(itemProps.index)"
          :src="itemProps.item.thumb.url"
          style="
            width: 128px;
            min-height: 128px;
            object-fit: cover;
            cursor: pointer;
          "
          alt="Galleriefoto"
        />
      </div>
    </template>
    <template v-slot:loading>
      <GalleryViewSkeletonLoader />
    </template>
  </GalleryGridUI>
</template>

<script lang="ts">
import { computed, defineComponent, inject, PropType, ref } from "vue"
import store from "store"
import axios from "initializers/axios"
import GalleryGridUI from "app/ui-primitives/gallery/GalleryGridUI.vue"
import {
  PhotoSwipeFetch,
  useLightbox,
} from "features/gallery/lightbox/lightbox.service"
import { getContextName, ViewContext } from "concerns/useContextName"
import GalleryViewSkeletonLoader from "features/gallery/view/GalleryViewSkeletonLoader.vue"

export default defineComponent({
  name: "DriveGalleryGrid",
  components: { GalleryViewSkeletonLoader, GalleryGridUI },
  props: {
    limit: {
      type: Number,
      required: true,
    },
    totalCount: {
      type: Number,
      required: true,
    },
    endpoint: {
      type: String,
      required: true,
    },
    folderId: {
      type: Number,
      required: true,
    },
    viewContext: {
      type: Object as PropType<ViewContext>,
    },
  },
  setup(props) {
    const allLoadedItems = computed(() => {
      return store.getters["drive/currentContents"]
    })

    const loadedCount = computed(() => {
      return allLoadedItems.value.length
    })

    const loadedItems = computed(() => {
      return allLoadedItems.value.filter((item) => item.type === "Photo")
    })

    const loadMore = async () => {
      loadingCount.value =
        props.limit <= props.totalCount - loadedCount.value
          ? props.limit
          : props.totalCount - loadedCount.value
      const endpointPaginated = `${props.endpoint}&limit=${props.limit}&offset=${loadedCount.value}`
      const { data } = await axios.get(endpointPaginated)
      store.commit("drive/updateInodes", data.results)
      store.commit("drive/setLoadingProgress", {
        inodeId: props.folderId,
        offset: loadedCount.value,
      })
      loadingCount.value = 0
    }

    const loadingCount = ref(0)

    const lightboxService = useLightbox()

    const fetchPhoto: PhotoSwipeFetch = async (index) => {
      const item = loadedItems.value[index]
      return {
        src: item.original.url,
        width: item.original.width,
        height: item.original.height,
        authorName: getContextName(props.viewContext, item.uploaded_by),
      }
    }

    const onImageClick = (startIndex) => {
      console.log("loeadedItems", loadedItems.value)
      lightboxService.openPhotoLightbox(
        startIndex,
        props.totalCount,
        fetchPhoto
      )
    }

    return {
      loadedItems,
      loadingCount,
      loadMore,
      onImageClick,
    }
  },
})
</script>
